<div class="body" *ngIf="!isLoading; else loading">
  <form class="form" id="welcomeForm" [formGroup]="welcomeForm" novalidate>
    <div class="top-bar">
      <div class="content-start"></div>
      <div class="logo-div">
        <img
          src="assets/images/ecolab-logo-white-app-header.png"
          alt="EcoLab Logo"
          class="logo"
        />
      </div>
      <div class="content-end">
        <select
          [value]="currentLanguage"
          (change)="languageChange($event)"
          class="select-dropdown"
        >
          <option
            *ngFor="let option of languageOptions"
            [value]="option?.value"
            [selected]="option.value === currentLanguage"
          >
            {{ option.value }}
          </option>
        </select>
      </div>
    </div>
    <main class="grow overflow-hidden main">
      <div class="h-full relative show-bottom-fade">
        <div class="h-full min-h-0 border-b border-white">
          <div class="max-w-xl mx-auto pt-2 px-2">
            <div class="grid grid-cols-12 gap-2 mb-4">
              <div class="col-span-4">
                <img
                  alt="EHT Dishmachine"
                  src="../../assets/images/devices/fpo-es-2000-dishmachine.jpg"
                  class="max-h-32 max-w-28 mx-auto machineImage"
                />
              </div>
              <div class="col-span-8">
                <h1 class="h1 sm:text-center">
                  {{ translations['welcome_page_message'] }}
                </h1>
              </div>
            </div>
            <div class="acc-section">
              <label for="accountNumber" class="accountLabel">{{
                translations['account_label_number']
              }}</label>
              <label for="accountNumber" class="descriptionLabel">{{
                translations['scan_instruction']
              }}</label>
              <div class="accnumber mb-3 mt-3">
                <div class="mx-0">
                  <input
                    type="number"
                    class="input"
                    maxlength="1"
                    formControlName="digit1"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    id="digit1"
                    (keydown)="onKeydown($event, 'digit1', 'digit0')"
                    (input)="onAccountNumberEntry($event, 'digit2')"
                    (keypress)="validateLength($event)"
                  />
                  <input
                    type="number"
                    class="input"
                    maxlength="1"
                    formControlName="digit2"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    (keydown)="onKeydown($event, 'digit2', 'digit1')"
                    id="digit2"
                    (input)="onAccountNumberEntry($event, 'digit3')"
                    (keypress)="validateLength($event)"
                  />
                  <input
                    type="number"
                    class="input"
                    maxlength="1"
                    formControlName="digit3"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    (keydown)="onKeydown($event, 'digit3', 'digit2')"
                    id="digit3"
                    (input)="onAccountNumberEntry($event, 'digit4')"
                    (keypress)="validateLength($event)"
                  />
                  <input
                    type="number"
                    class="input"
                    maxlength="1"
                    formControlName="digit4"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    (keydown)="onKeydown($event, 'digit4', 'digit3')"
                    id="digit4"
                    (input)="onAccountNumberEntry($event, 'digit5')"
                    (keypress)="validateLength($event)"
                  />
                </div>
                <div>
                  <input
                    type="number"
                    class="input"
                    maxlength="1"
                    formControlName="digit5"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    (keydown)="onKeydown($event, 'digit5', 'digit4')"
                    id="digit5"
                    (input)="onAccountNumberEntry($event, 'digit6')"
                    (keypress)="validateLength($event)"
                  />
                  <input
                    type="number"
                    class="input"
                    maxlength="1"
                    formControlName="digit6"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    id="digit6"
                    (keydown)="onKeydown($event, 'digit6', 'digit5')"
                    (input)="onAccountNumberEntry($event, 'digit7')"
                    (keypress)="validateLength($event)"
                  />
                  <input
                    type="number"
                    class="input"
                    maxlength="1"
                    formControlName="digit7"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    id="digit7"
                    (keydown)="onKeydown($event, 'digit7', 'digit6')"
                    (input)="onAccountNumberEntry($event, 'digit8')"
                    (keypress)="validateLength($event)"
                  />
                  <input
                    type="number"
                    class="input"
                    maxlength="1"
                    formControlName="digit8"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    id="digit8"
                    (keydown)="onKeydown($event, 'digit8', 'digit7')"
                    (input)="onAccountNumberEntry($event, 'digit9')"
                    (keypress)="validateLength($event)"
                  />
                </div>
                <div class="mx-0">
                  <input
                    type="number"
                    class="input input-last"
                    maxlength="1"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    formControlName="digit9"
                    id="digit9"
                    (keydown)="onKeydown($event, 'digit9', 'digit8')"
                    (keypress)="validateLength($event)"
                    (input)="onAccountNumberEntry($event, 'digit10')"
                  />
                  <input
                    type="number"
                    class="input input-last"
                    maxlength="1"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    formControlName="digit10"
                    id="digit10"
                    (keydown)="onKeydown($event, 'digit10', 'digit9')"
                    (keypress)="validateLength($event)"
                    (input)="onAccountNumberEntry($event, 'digit10')"
                  />
                </div>
              </div>
              <div *ngIf="showAlert">
                <label class="alert">Account Number not found!</label>
              </div>
            </div>
            <!-- <div class="mb-4" (click)="toggleScanner()">
              <img
                src="../../assets/images/icon/sacn-vector.jpg"
                class="scan-sec me-2"
              />
              <label for="accountNumber" class="label">{{
                translations['scan_title']
              }}</label>
              <div *ngIf="scanEnable">
                <app-scanQrCode
                  (dataEvent)="handleData($event)"
                ></app-scanQrCode>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </main>
    <div class="layout-bottom">
      <div *ngIf="!isNextDisabled" class="max-w-xl mx-auto">
        <div>
          <p class="p terms">
            <span> {{ translations['tapping_next'] }} </span>
          </p>
          <p class="terms">
            <span> {{ translations['the_ecolab'] }} </span
            ><a href=""> {{ translations['privacy_policy'] }}</a
            ><span> {{ translations['and'] }} </span>
            <a href=""> {{ translations['terms_and_conditions'] }}</a>
          </p>
        </div>
      </div>
      <div class="max-w-xl mx-auto px-4">
        <button
          type="submit"
          [disabled]="isClearDisabled"
          class="btn-white-outline"
          (click)="clear()"
        >
          {{ translations['clear_all'] }}
        </button>
        <button
          type="submit"
          [disabled]="isNextDisabled"
          id="nextButton"
          class="btn-blue-outline"
          (click)="nextClick()"
        >
          {{ translations['next'] }}
        </button>
      </div>
    </div>
  </form>
</div>

<ng-template #loading>
  <div class="top-bar">
    <div class="content"></div>
    <div>
      <img
        src="assets/images/ecolab-logo-white-app-header.png"
        alt="EcoLab Logo"
        class="logo"
      />
    </div>
    <div class="content-end">
      <!-- <select>
                <option>English</option>
                <option>Spanish</option>
            </select> -->
    </div>
  </div>
  <div class="d-flex justify-content-center pt-3">
    <div class="loading">Loading</div>
  </div>
</ng-template>
